'use client';
import { NotiDataType, NotificationType } from "@/core/models/notification";
import NotificationContext from "./context";
import { useState, useEffect, useCallback } from "react"
import { SumsubService } from "@/core/services/sumsubService";
import { TravelRuleStatus } from "@/store/auth/enum";
import i18n from "@/i18n";

const TRAVEL_RULE_NOTIFICATION_ID = 'travel-rule-notification';

export default function NotificationProvider({ children }: { children: React.ReactNode }) {
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false)
  const [action, setAction] = useState<string>('')
  const [dataNotification, setDataNotification] = useState<NotiDataType[]>([])

  const checkTravelRuleStatus = useCallback(async () => {
    try {
      const status = await SumsubService.getTravelRuleStatus();
      const needsAction =
        status.status === TravelRuleStatus.NEEDED ||
        status.status === TravelRuleStatus.FAILED;

      setDataNotification((prev) => {
        // Remove existing travel rule notification
        const filtered = prev.filter((n) => n.id !== TRAVEL_RULE_NOTIFICATION_ID);

        if (needsAction) {
          const transactionType = status.is_deposit
            ? i18n.t('travel-rule.deposit')
            : i18n.t('travel-rule.withdraw');

          const travelRuleNotification: NotiDataType = {
            id: TRAVEL_RULE_NOTIFICATION_ID,
            type: NotificationType.TRAVEL_RULE,
            title: i18n.t('travel-rule.notification_title'),
            content: i18n.t('travel-rule.notification_content', { type: transactionType }),
            read: false,
            time: new Date(),
            actionType: 'travel_rule',
          };

          return [travelRuleNotification, ...filtered];
        }

        return filtered;
      });
    } catch (error) {
      // Silently fail - user may not have any travel rule requirements
      console.debug('No travel rule status found or error fetching:', error);
    }
  }, []);

  useEffect(() => {
    checkTravelRuleStatus();
  }, [checkTravelRuleStatus]);

  return (
    <NotificationContext.Provider value={{
      openConfirmModal: openConfirmModal,
      action: action,
      dataNotification: dataNotification,
      setOpenConfirmModal: setOpenConfirmModal,
      setAction: setAction,
      setDataNotification: setDataNotification
    }}>
      {children}
    </NotificationContext.Provider>
  )
}
